import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Helper } from 'src/app/shared/utils/helper';
import { environment } from 'src/environments/environment';
import { CITService } from '../../services/cit.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
  public INVITED_ID = this.route.snapshot.params.id;
  loading:boolean=true;
  form:FormGroup;
  constructor(
    private fb:FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private emsService:CITService,
    private toast:ToastrService
  ) {
  }

  ngOnInit(){
    const id = this.route.snapshot.params.id;
    if (Helper.isEmpty(id)) {
      return this.router.navigate(['./cit']);
    }
    this.getInvitedUser(id);
    this.createForm();
  }

  getInvitedUser(id){
    this.loading = true;
    Helper.preventToast();
    this.emsService.getInvitedUser(id).pipe(
      tap((res:any)=>{
        this.loading = false;
        this.bindData(id, res.result);
        this.loading = false
      }),
      catchError((error) => {
        this.loading = false
        Helper.clearPreventedToast();
        let message = "No internet connection or server is unavailable.";
        if (error.error.error) {
          message = error.error.error.message;
        }
        return (this.router.navigate(['./error-404', message]),EMPTY);
      })
    )
    .subscribe();
  }

  bindData(id, data){
    return this.form.patchValue(
      {
        id: id,
        name: data.firstName,
        surname: data.lastName,
        emailAddress: data.emailAddress
      }
    )
  }

  private createForm(){
    this.form = this.fb.group({
      id: [null, [Validators.required]],
      name: [null, [Validators.required]],
      surname: [null, [Validators.required]],
      phoneNumber: [null, [Validators.required]],
      emailAddress: [null, [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
      confirmPassword: [null, [Validators.required]]
    }, {validators: this.mustMatch('password','confirmPassword')})
  }

  onSubmit(){
    const data = this.form.getRawValue();
    if (this.form.invalid) {
      return this.form.markAllAsTouched();
    }
    this.emsService.register(data).pipe(
      tap((res)=>{
        this.toast.success("Successfully Registered", null, {timeOut:6000});
        // if (res.result=="EMS") {
        //   window.location.href = `${environment.emsRoot}/ems?env=${res.result}`;
        // }
        // if (res.result=="CIT") {
        //   window.location.href = `${environment.citRoot}/cit?env=${res.result}`;
        // }
        this.router.navigate(['./login']);
      }),
      catchError((error) => {
        return (of(EMPTY),
          this.router.navigate(['./404-page', error.error.message])
        );
      })
    ).subscribe();
  }

  private mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];
      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }
      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }


  get getPasswords() {
    const { password, confirmPassword } = this.form.getRawValue();
    return { password, confirmPassword };
  }

  hasCapitalLetter(): boolean {
    const rgx = /^(?=.*[A-Z])/.test(this.getPasswords.password);
    return !rgx;
  }
  hasSmallLetter(): boolean {
    const rgx = /^(?=.*[a-z])/.test(this.getPasswords.password);
    return !rgx;
  }

  hasNumber(): boolean {
    const rgx = /^(?=.*[0-9])/.test(this.getPasswords.password);
    return !rgx;
  }

  get myform(){
    return this.form.controls;
  }
}
